import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  HostBinding,
  OnDestroy,
  QueryList,
} from '@angular/core';
import { BannerComponent } from '@zelis/dls/banner';
import { combineLatest, Subject } from 'rxjs';
import { startWith, switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'zelis-banner-list',
  templateUrl: './banner-list.component.html',
  styleUrls: ['./banner-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerListComponent implements AfterContentInit, OnDestroy {
  @HostBinding() class = 'zelis-dls';
  @ContentChildren(BannerComponent) banners!: QueryList<BannerComponent>;

  private destroy: Subject<void> = new Subject();

  ngAfterContentInit() {
    this.updateBannerIconsOnClosed();
    this.updateBannerIcons();
  }

  ngOnDestroy() {
    this.destroy.next(undefined);
  }

  private updateBannerIcons() {
    let previousStatus;
    for (const banner of this.banners) {
      if (banner.isClosed) {
        continue;
      }
      if (previousStatus !== banner.status) {
        banner.showIcon = true;
      } else {
        banner.showIcon = false;
      }
      previousStatus = banner.status;
    }
  }

  private updateBannerIconsOnClosed() {
    this.banners.changes
      .pipe(
        switchMap((banners: BannerComponent[]) =>
          combineLatest(
            banners.map((banner) => banner.closed.pipe(startWith(null)))
          )
        ),
        takeUntil(this.destroy)
      )
      .subscribe(() => this.updateBannerIcons());
    // Emit changes at least once
    this.banners.notifyOnChanges();
  }
}
